import { useQuery } from "react-query";

import api from "../../../api";
import { FIVE_MINUTES } from "../../_helpers/constants";

export enum DocumentMimeType {
  JPEG = "image/jpeg",
  PNG = "image/png",
  JPG = "image/jpg",
  HEIC = "image/heic",
}

export type DocumentType = "photo-id"; // only "photo-id" is supported for now

interface ClientDocumentResponse {
  presigned_url: string;
  client_document_id: string;
  mime_type: DocumentMimeType;
  size: string;
  uploaded_at: string;
}

interface GetClientDocumentByTypeParams {
  clientId: number;
  documentType: DocumentType;
}

const getClientDocumentByType = async ({
  clientId,
  documentType,
}: GetClientDocumentByTypeParams) => {
  try {
    const { data } = await api.get<ClientDocumentResponse>(
      `/api/client_documents/v1/get_presigned_document_read_url/`,
      {
        params: { client_id: clientId, document_type: documentType },
      },
    );
    return data;
  } catch (e) {
    throw new Error(`[getClientDocumentByType] Unable to fetch: ${e}`);
  }
};

export const useGetClientDocumentByType = ({
  clientId,
  documentType,
  enabled,
}: {
  clientId: number;
  documentType: DocumentType;
  enabled: boolean;
}) => {
  return useQuery(
    ["ClientDocumentByType", clientId],
    () => getClientDocumentByType({ clientId, documentType }),
    {
      staleTime: FIVE_MINUTES,
      enabled: !!clientId && !!documentType && enabled,
    },
  );
};
